<!-- ============================================================== -->
<!-- Main wrapper - style you can find in pages.scss -->
<router-outlet></router-outlet>